
'use strict';

var $ = require('jquery'),
  $global = require('../globalElements'),
  Backbone = require('backbone'),

  ImageOverlayView = Backbone.View.extend({

    events: {
      click: 'close',
      'click .ImageOverlay-wrapper': 'stopBubble',
      'click .ImageOverlay-close': 'close',
      'keydown .ImageOverlay-wrapper': 'closeOnEsc'
    },

    initialize: function() {
      this.$img = false;
      this.$wrapper = this.$('.ImageOverlay-wrapper');
      this.$lastFocusableElement = this.$('button.ImageOverlay-close');
      this.$firstFocusableElement = this.$('button.ImageOverlay-close');
    },

    createImage: function(src, alt) {
      this.$img = $('<img>', {
        src: src,
        class: 'ImageOverlay-image',
        alt: alt,
        'aria-hidden': true
      });
      this.$wrapper.append(this.$img);
    },

    open: function(link, alt) {
      if (!link) {
        return;
      }

      if (this.$img) {
        this.$img.attr('src', link);
        this.$img.attr('alt', alt);
      } else {
        this.createImage(link, alt);
      }
      this.$firstFocusableElement.on('keydown',(e)=>{
        if (e.key === 'Tab' && e.shiftKey) {
          e.preventDefault();
          this.$lastFocusableElement.focus();
        }
      });
      this.$lastFocusableElement.on('keydown', (e)=>{
        if (e.key === 'Tab' && !e.shiftKey) {
          e.preventDefault();
          this.$firstFocusableElement.focus();
        }
      });

      this.$wrapper.attr('aria-modal',true);
      $global.$body.addClass('has-image-overlay');
    },

    close: function() {
      $global.$body.removeClass('has-image-overlay');
      this.$wrapper.removeAttr('aria-modal');
      $('a.ImageCarousel-enlarge').focus();
    },

    stopBubble: function(e) {
      e.stopPropagation();
    },

    closeOnEsc: function(e) {
      if (e.key === 'Escape') {
        this.close();
      }
    }

  }, {
    create: function($parent) {

      var $links = $parent.find('[data-img-enlarge]');

      // If they are links opening the image overlay, create the element
      if ($links.length) {

        var imageOverlayView = new ImageOverlayView({
          el: $parent.find('.ImageOverlay')
        });

        // Open the image overlay on every click
        $links.click(function(e) {
          e.preventDefault();
          let $img = $(this).find('img').first();
          let alt = '';
          if ($img && $img.length) {
            alt = $img.attr('alt') || '';
          }
          if (!alt) {
            let $heading = $('h1.ReferenceDetail-header-title');
            if ($heading && $heading.length) {
              alt = $heading.text().replace(/[\r\n]+/gm, '').trim();
            }
          }

          if (alt) {
            if (alt.slice(-1) !== '.') {
              alt += '.';
            }
          }
          imageOverlayView.open($(this).attr('href'), alt);
          setTimeout(() => {
            $('button.ImageOverlay-close').focus();
          }, 150);
        });

      }

    }
  });

module.exports = ImageOverlayView;



// WEBPACK FOOTER //
// ./assets/js/components/ImageOverlayView.js